<script setup lang="ts">
import { onMounted } from 'vue';
import { globalRolleCollection, Rolle } from '@/models/Rolle';
import Column from 'primevue/column';
import { getI18n } from '@/helpers/i18n';
import { useToast } from 'primevue/usetoast';
import { errToToast } from '@/helpers/tools';
import KpBaseGrid from '@/components/KpBaseGrid.vue';
import { useRoute, useRouter } from 'vue-router';
import { buildUrl } from '@/helpers/api';

const router = useRouter();
const route = useRoute();
const toast = useToast();

const collection = globalRolleCollection();

onMounted(() => {
    if (collection.loading.value !== true) {
        collection.query();
    }
});

function editRecord(r: Rolle) {
    router.push({ name: 'system_rolle_edit', params: { id: r?.id } });
}

async function deleteRecord(r: Rolle) {
    if (window.confirm(getI18n().t('sicher_loeschen'))) {
        try {
            await r.destroy();
            await collection.query();
        } catch (e) {
            errToToast(e, toast);
        }
    }
}

function newRecord() {
    router.push({ name: 'system_rolle_edit', params: { id: 'new' } });
}

async function onCsvDownload() {
    const params = collection.queryParams;
    params.output = 'csv';
    const url = buildUrl('/' + collection.getModelClassName() + '/list', params);
    window.open(url, 'csvExport');
}
</script>
<template>
    <div style="height: 100%">
        <KpBaseGrid
            :value="collection.getModels()"
            :title="$t('rollen')"
            :loading="collection.loading.value"
            sort-field="reihenfolge"
            state-storage="session"
            :state-key="route.fullPath"
            scrollable
            scroll-height="flex"
            @editrecord="editRecord($event as Rolle)"
            @deleterecord="deleteRecord($event as Rolle)"
            @new="newRecord"
            @csvdownload="onCsvDownload"
        >
            <Column field="id" sortable :header="$t('id')" style="width: 5rem"></Column>
            <Column field="bezeichnung" sortable :header="$t('bezeichnung')"></Column>
            <Column field="reihenfolge" sortable :header="$t('reihenfolge')" style="width: 5rem"></Column>
        </KpBaseGrid>
    </div>
</template>
